import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { sendSms, validateSms } from "../../api/smsApi";
import { findAccountAtom } from "../../recoil/atoms";

export const useSendSms = () => {
  const navigate = useNavigate();

  const onError = ({
    response: {
      data: { code, message },
    },
  }) => {
    alert(message);
    if (code === "INVALID_PHONE" || code === "SMS_SEND_FAILURE") {
      navigate(-1);
    } else if (code === "USER_NOT_FOUND_BY_PHONE") {
      window.location.href = "/";
    }
  };
  const onSuccess = () => {};
  return useMutation(sendSms, {
    onError,
    onSuccess,
  });
};

export const useReSendSms = (setIsSmsSending) => {
  const onError = ({
    response: {
      data: { code, message },
    },
  }) => {
    if (code === "INVALID_PHONE" || code === "SMS_SEND_FAILURE") {
      alert(message);
    }
  };
  const onSuccess = () => {
    setIsSmsSending(false);
  };
  return useMutation(sendSms, {
    onError,
    onSuccess,
  });
};

// 인증 확인 훅
export const useValidateSms = () => {
  const navigate = useNavigate();

  const setFindAccountAtom = useSetRecoilState(findAccountAtom);
  const onError = ({
    response: {
      status,
      data: { code, message },
    },
  }) => {};
  const onSuccess = ({ data: { isValid, message, username } }) => {
    if (!isValid) {
      setFindAccountAtom((prev) => ({
        ...prev,
        smsMessage: message,
      }));
    } else {
      setFindAccountAtom((prev) => ({
        ...prev,
        username,
      }));
      navigate("/find-account/password", { replace: true });
    }
  };
  return useMutation(validateSms, {
    onError,
    onSuccess,
  });
};
